export default __webpack_public_path__ + "static/media/prevIcon.dfb9fe6e.svg";